import "./PremiumSport.css";

// Port of bajifair-admin's PremiumSport: each market controls its own expand
// state and renders sportsBookSelection as two columns of Back prices.
export default function PremiumSport({ data, handelPremiumFancy }) {
  return <section className="analytics-premium analysis-running-market" aria-label="Sportsbook / Premium Fancy">
    {data.map((market) => <section key={market.id} className="main-analysis mb-2" aria-label={market.marketName}>
      <div className="top">
        <div className="toptitle d-inline" title={market.marketName}>{market.marketName}</div>
        <div className="min-max d-inline">
          <span className="desktop-minmax">Min: {market.min ?? 100} | Max: {market.max ?? 100000}</span>
          <button type="button" className="premium-toggle" aria-expanded={market.expand}
            aria-label={`${market.expand ? "Collapse" : "Expand"} ${market.marketName}`}
            onClick={() => handelPremiumFancy(market.id)}>
            <i className={`fa fa-${market.expand ? "minus" : "plus"}`} aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="table-responsive analysis-running-market bookmakerbs">
        <div className="container-fluid">
          <div className="row"><div className="col-12 p-right-left">
            <span className="mobile-minmax-winnerodds">Min: {market.min ?? 100} | Max: {market.max ?? 100000}</span>
          </div></div>
          {market.sportsBookSelection.length > 0 && market.expand && <div className="row">
            {market.sportsBookSelection.map((selection) => <div key={selection.id ?? selection.selectionName}
              className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 border-top1 p-right-left">
              <div className="d-inline-flex w-100 lottery-p-2 odds">
                <div className="d-inline-block lottery-w75 lottery-inplay v-align-top p-relative">
                  <div className="d-inline-block">
                    <span className="in-play-title in-play-title-winnerodds">{selection.selectionName}</span>
                  </div>
                  <div className="d-inline-block runnerid float-right p-absolute winner-right4" />
                </div>
                <div className="d-inline-block lottery-w25 lottery-inplay btn-back">
                  <div className="btn-back border-bottom1 w-100 text-center d-block font-weight-bold">{selection.odds ?? "-"}</div>
                </div>
              </div>
            </div>)}
          </div>}
        </div>
      </div>
    </section>)}
  </section>;
}
